import script from "./ExamResultMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamResultMain.vue?vue&type=script&setup=true&lang=ts"

import "./ExamResultMain.vue?vue&type=style&index=0&id=4831ae88&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4831ae88"]])

export default __exports__